module.exports = __webpack_public_path__ + "static/media/champion07.b0600ce6.jpg";